<email-performance
  [attribute]="attribute"
  [stats]="statsData$ | async"
  [emailActivityUrl]="campaignActivityTableUrl$ | async"
></email-performance>
<email-link-performance
  [linkActivityPath]="'/link-activity/' + attribute.key + '/' + attribute.value"
  [linkActivity]="linkActivity$ | async"
  [backUrl]="backUrl"
></email-link-performance>
<email-delivery-status
  [attribute]="attribute"
  [stats]="statsData$ | async"
  [emailActivityUrl]="campaignActivityTableUrl$ | async"
></email-delivery-status>
